<template>
    <div class="header">
        <Area width="1473" v-on="$listeners"/>
    </div>
</template>

<script>
    import Area from "../../components/OperatingEnvironment/Area";
    export default {
        name: "Header",
        components: {
            Area
        },
        data() {
			return {
			}
		},
    }
</script>

<style lang="less" scoped>
    .header {
        .w(1600);
        .h(96);
        background: #FFFFFF;
        box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
    }
</style>